<script>
  import { result } from "../store.js";
  import { createEventDispatcher } from "svelte";
  import InputCard from "./InputCard.svelte";
  import InputText from "./InputText.svelte";
  import InputNumber from "./InputNumber.svelte";
  import InputSelect from "./InputSelect.svelte";
  import InputSingle from "./InputSingle.svelte";
  import InputMultiple from "./InputMultiple.svelte";
  import InputTextArea from "./InputTextArea.svelte";
  import InputDate from "./InputDate.svelte";
  import InputDateRange from "./InputDateRange.svelte";
  import InputTime from "./InputTime.svelte";
  import { validateInput } from "../validate";
  export let item;
  export let index = 0;
  export let total = 0;
  export let current = 0;
  export let errors = [];
  export let buttonColor = "#000";
  export let isSingle = false;
  export let lang = "en";

  const dispatch = createEventDispatcher();

  function next() {
    //Validate befor continue
    errors = validateInput(item, $result[index], lang);
    if (errors.length > 0) return;
    dispatch("next", {
      nextIndex: 1 + index,
    });
  }
</script>

<InputCard {index}>
  <div>
    <small>{isSingle ? current + 1 : index + 1}/{total}</small>
    <h3>{item.title}</h3>
    <div class="optional">
      {#if !item.required}
        <small>{lang === "es" ? "(opcional)" : "(optional)"}</small>
      {/if}
    </div>
    {#if item.type === "text"}
      <InputText {item} {index} />
    {:else if item.type === "number"}
      <InputNumber {item} {index} />
    {:else if item.type === "select"}
      <InputSelect {item} {index} />
    {:else if item.type === "single-option"}
      <InputSingle {item} {index} />
    {:else if item.type === "multi-option"}
      <InputMultiple {item} {index} />
    {:else if item.type === "text-area"}
      <InputTextArea {item} {index} />
    {:else if item.type === "date"}
      <InputDate {item} {index} {current} />
    {:else if item.type === "date-range"}
      <InputDateRange {item} {index} {current} />
    {:else if item.type === "time"}
      <InputTime {item} {index} />
    {/if}
    <p>{item.description}</p>
    {#if isSingle ? current + 1 !== total : index === current && index + 1 !== total}
      <div>
        <button
          class="btn secondary"
          type="button"
          on:click={next}
          style="background:{buttonColor || '#000'}"
        >
          {lang === "es" ? "Siguiente" : "Next"}
        </button>
      </div>
    {/if}
    {#if errors && errors.length > 0}
      {#each errors as error}
        <p class="error">{error}</p>
      {/each}
    {/if}
  </div>
</InputCard>

<style>
  p {
    margin: 0;
    font-size: 12px;
  }
  h3 {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .optional {
    margin-top: 0.2rem;
    margin-bottom: 0.6rem;
  }
  button {
    padding: 10px;
    width: 50%;
    margin-right: auto;
    margin-left: auto;
  }
  .error {
    color: #f75d59;
  }
</style>
